import {
	createStore
} from 'vuex'
import {
	setMenu,
	removeToken,
	removeUser,
	removeMenu
} from '../utils/auth'
import {setDict} from '../utils/formatDic'

import $axios from '../utils/request'
import router from '@/router/router'
import queryApi from "@/utils/request";
// 获取用户详细信息
const getMenus = () => {
	return queryApi({
		url: '/ac/login/menu',
		data: {
			appCode: process.env.VUE_APP_CODE
		}
	}, "post");
}

const getDD = () => {
	return queryApi({
	    url: '/md/mdCommonType/getAllCommonTypes',
	    data: {
			param_0:{
				appCode:process.env.VUE_APP_CODE
			}
		},
	}, "post")

}
// 获取页面配置
const getPageConfig = (resId) => {
	return queryApi({
			url: "/md-page-config/findPageConfigByPageId",
			data: {
				pageId: resId
				// pageId: "IIOT010102"
			}
		},'post')
}

export function logout() {
	return $axios({
		url: '/itmp/authpre/logout',
		method: 'post'
	})
}

export default createStore({
	state: {
		tagsList: [],
		collapse: false,
		token: null,
		menus: [],
		user:{},
		dd: [], //数据字典
		otherTagsList: false,
		massageData: {},
	},
	mutations: {
		SET_PAGECONFIG: (state, pageConfig) => {
			state.pageConfig = pageConfig
		},
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_MENUS: (state, menus) => {
			state.menus = menus
		},
		RESET_MENUS:(state)=>{
			state.menus = []
		},
		SET_DD: (state, dds) => {
			state.dd = dds
		},
		delTagsItem(state, data) {
			state
				.tagsList
				.splice(data.index, 1);
		},
		setTagsItem(state, data) {
			state
				.tagsList
				.push(data)
		},
		otherTagsItem(state, data) {
			state.otherTagsList = data
		},
		clearTags(state) {
			state.tagsList = []
		},
		closeTagsOther(state, data) {
			state.tagsList = data;
		},
		closeCurrentTag(state, data) {
			for (let i = 0, len = state.tagsList.length; i < len; i++) {
				const item = state.tagsList[i];
				if (item.path === data.$route.fullPath) {
					if (i < len - 1) {
						data
							.$router
							.push(state.tagsList[i + 1].path);
					} else if (i > 0) {
						data
							.$router
							.push(state.tagsList[i - 1].path);
					} else {
						data
							.$router
							.push("/");
					}
					state
						.tagsList
						.splice(i, 1);
					break;
				}
			}
		},
		// 侧边栏折叠
		handleCollapse(state, data) {
			state.collapse = data;
		},
		SET_REFERENCE: (state, data) => {
			state.references = data
		},
		SET_MESSAGEDATA: (state, data) => {
			state.massageData = data
		},
		setUser:(state,user)=>{
			state.user = user;
		},
		clearUser(state){
			state.user = {};
		},
	},
	getters:{
		getUser:state=>state.user
	},
	actions: {
		// 获取页面配置
		async GetPageConfig({commit,state},resId) {
			return new Promise((resolve, reject) => {
				getPageConfig(resId).then(res => {
					commit('SET_PAGECONFIG', res ? res : "")
					if(res.data){

					}else{
						sessionStorage.setItem("pageConfig", JSON.stringify(res));
					}
					resolve()
				})
			})
		},
		// 插入消息
		async SetMessageData({commit,state},data) {
			return new Promise((resolve, reject) => {
				commit('SET_MESSAGEDATA', data ? data : "");
				setTimeout(() => {
					commit('SET_MESSAGEDATA', "");
				},1000)
				resolve()
			})
		},
		async getMenus({commit,state}) {
			return new Promise((resolve, reject) => {
				getMenus().then(res => {
					let menus = res || [];
					commit('SET_MENUS', menus)
					setMenu(menus);
					resolve(menus)
				})
			})
		},
		async GetDD({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				getDD().then(res => {
					commit('SET_DD', res || "")
					setDict(res||{});
					resolve()
				})
			})
		},
		// 退出系统
		LogOut({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				removeUser();
				removeToken();
				removeMenu();
				commit('RESET_MENUS');
				router.push("/login");
				resolve(); //?
			})
		}
	},
	modules: {}
})
